export const SET_USER_ROLE                    = 'SET_USER_ROLE';

export const SET_INST_RECID                   = 'SET_INST_RECID';
   
export const RESET_SMART_CANVAS               = 'RESET_SMART_CANVAS';
   
//Instance Data   
export const REQUEST_INSTANCE_DATA            = 'REQUEST_INSTANCE_DATA';
export const RECEIVE_INSTANCE_DATA_SUCCESS    = 'RECEIVE_INSTANCE_DATA_SUCCESS';
export const RECEIVE_INSTANCE_DATA_ERROR      = 'RECEIVE_INSTANCE_DATA_ERROR';
   
export const CHANGE_TITLE                     = 'CHANGE_TITLE';
export const CHANGE_SCENE                     = 'CHANGE_SCENE';
export const CHANGE_ZONE_TEXT                 = 'CHANGE_ZONE_TEXT';
export const CHANGE_ZONE_COLOR                = 'CHANGE_ZONE_COLOR';
   
export const SET_ACTIVE_ZONE                  = 'SET_ACTIVE_ZONE';
export const REMOVE_ASSET                     = 'REMOVE_ASSET';
export const UPDATE_ZONE_ASSET_DICT           = 'UPDATE_ZONE_ASSET_DICT';
export const ASSIGN_ASSET                     = 'ASSIGN_ASSET';
export const IS_ASSIGNING_ASSET               = 'IS_ASSIGNING_ASSET';
 
//Saving 
export const REQUEST_SAVE_INSTANCE            = 'REQUEST_SAVE_INSTANCE';
export const RECEIVE_SAVE_INSTANCE_SUCCESS    = 'RECEIVE_SAVE_INSTANCE_SUCCESS';
export const RECEIVE_SAVE_INSTANCE_ERROR      = 'RECEIVE_SAVE_INSTANCE_ERROR';

//Saving As
export const REQUEST_SAVE_AS_INSTANCE         = 'REQUEST_SAVE_AS_INSTANCE';
export const RECEIVE_SAVE_AS_INSTANCE_SUCCESS = 'RECEIVE_SAVE_AS_INSTANCE_SUCCESS';
export const RECEIVE_SAVE_AS_INSTANCE_ERROR   = 'RECEIVE_SAVE_AS_INSTANCE_ERROR';

//Toggle Zone display
export const TOGGLE_HIDE_ZONE                 = 'TOGGLE_HIDE_ZONE';
export const TOGGLE_ALL_ZONES                 = 'TOGGLE_ALL_ZONES';
 
//Toolbox Actions 
export const TOGGLE_MEDIA_PICKER              = 'TOGGLE_MEDIA_PICKER';
export const SCALE_IMAGE                      = 'SCALE_IMAGE';
export const FLIP_IMAGE                       = 'FLIP_IMAGE';
export const ROTATE_IMAGE                     = 'ROTATE_IMAGE';
export const TOGGLE_MOVE_IMAGE                = 'TOGGLE_MOVE_IMAGE';
export const TOGGLE_COLOR_PICKER              = 'TOGGLE_COLOR_PICKER';
export const PREVIEW_INSTANCE                 = 'PREVIEW_INSTANCE';
export const CLOSE_PREVIEW                    = 'CLOSE_PREVIEW';
 
export const SAVE_AS_STATE                    = 'SAVE_AS_STATE';
export const UNSAVED_NAVIGATION_STATE         = 'UNSAVED_NAVIGATION_STATE';

export const EDITS_MADE                       = 'EDITS_MADE';

export const ADMIN_UNLOCK_MODAL               = 'ADMIN_UNLOCK_MODAL';

export const CLOSE_UNLOCK_MODAL               = 'CLOSE_UNLOCK_MODAL';

export const SET_ERROR_MESSAGE                = 'SET_ERROR_MESSAGE';
export const CLOSE_MODAL                      = 'CLOSE_MODAL';

export const INSTANCE_LOCKED                  = 'INSTANCE_LOCKED';
export const INSTANCE_UNLOCKED                = 'INSTANCE_UNLOCKED';

/*Errors */
export const UNIQUE_TITLE_ERROR               = 'UNIQUE_TITLE_ERROR';
